module.exports = function(locale, preview, filters) {
  return `
fragment ComponentWidthFragment on ComponentWidth {
  sys {
    id
  }
  name
  desktopComponentWidth
  smartphoneComponentWidth
  tabletComponentWidth
}
fragment ImageSetFragment on ImageSet {
  sys {
    id
  }
  styles
  __typename
  name
  altText
  desktopImage {
    title
    url
    fileName
    contentType
  }
  tabletImage {
    title
    url
    fileName
    contentType
  }
  smartphoneImage {
    title
    url
    contentType
    fileName
  }
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
}
fragment CardFragment on Callout {
  sys {
    id
  }
  __typename
  name
  styles
  variant
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
  image {
    __typename
    ...on Image{
      altText
    tooltip
    image {
      title
      url
      fileName
    }
    }
    ...on ImageSet{
      ...ImageSetFragment
    }
  }
  title
  subTitle
  text
  supportingText
  callToActionsCollection(limit: 3) {
    ... on CalloutCallToActionsCollection {
      items {
       
        ... on LinkButton {
          ...LinkButtonFragment
        }
        ... on ImageButton {
          ...ImageButtonFragment
        }
      }
    }
  }
}



fragment LinkButtonFragment on LinkButton {
  __typename
  sys {
    id
  }
  name
  styles
  link
  linkText
  tooltip
  gaEventClass
  variant
  target
  referencePageCollection(limit: 1) {
    ... on LinkButtonReferencePageCollection {
      items {
        ... on Product {
          sys {
            id
          }
          gtin
          slug
        }
      }
    }
  }
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
}

fragment ImageButtonFragment on ImageButton {
    sys {
      id
    }
    name
    styles
    altText
    linkText
    link
    tooltip
    gaEventClass
    target
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    image {
      url
      fileName
      contentType
      title
    }
    __typename
  }

fragment PageMetaDataFragment on PageMetaData {
  sys {
    id
  }
  __typename
  pageTitle
  metaTitle
  metaDescription
  metaKeywords
  openGraphPageTitle
  openGraphDescription
  ogImage:openGraphImage{
    url
  }
}

fragment HeadingFragment on HeadingTypes {
    sys {
      id
    }
    styles
    headingName
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    heading
    __typename
  }

  
  fragment VideoArticleFragment on VideoCard {
    sys{
      id
    }
    title
    name
    text
    styles
    componentWidth {
      name
      desktopComponentWidth
      smartphoneComponentWidth
      tabletComponentWidth
    }
    video {
      title
      videoLink
      autoplay
      videoMobileThumbnail {
        url
      }
      videoThumbnail {
        title
        fileName
        url
      }
    }
    callToActionsCollection {
      items {
        ... on ImageButton {
          __typename
          imageMobile{
            url
          
          }
          name
          image {
            title
            url
          }
        }
      }
    }
  }


{
  articleCollection(limit: 1, locale: "${locale}", preview: ${preview}, where: {slug: "${filters.slug}"}) {
    items {
      sys {
        id
      }
      name
      slug
      title
      shortDescription
      breadcrumbTitle
      variant
      sitemapTitle
       heroImage{
        title
        fileName
        url
        contentType 
        description       
      }
      pageMetadata {
        ... on PageMetaData {
          ...PageMetaDataFragment
        }
      }
      pageContentCollection {
        items {
          sys {
            id
          }
        }
      }
      navigation {
        title
        menuSlotsCollection(limit: 50) {
          items {
            name
            title
            link
            menuItemsCollection(limit: 10) {
              items {
                menuText
                menuLink
                textOnly
              }
            }
          }
        }
      }
      relatedArticlesCollection(limit: 10) {
        items {
          __typename
          ... on Article {
            sys{
              id
            }
            name
            slug
            title
            cardTitle
            shortDescription
            heroImage {
              title
              fileName
              url
              contentType
              description
            }
            parentPage {
              __typename
              ...on ArticleList{
                slug
                title
              }
              ...on ContentPage{
                slug
                title
              }
            }
          }
        }
      }
      additionalInformationCollection(limit: 10){
        items {
            __typename
            ... on SectionContainer {
              sectionContentCollection(limit: 9) {
                items {
                  __typename
                  ... on HeadingTypes {
                    heading
                    headingName
                  }
                  ... on ContentTypeRichText {
                    body
                  }
                }
              }
            }
            ... on LinkButton {
              link
              linkText
              styles
            }
            ... on ContentTypeRichText {
              body
            }
          }
      }
         bannerImageCollection{
        items {
          sys {
            id
          }
          styles
          __typename
          name
          altText
          desktopImage {
            title
            url
            fileName
            contentType
          }
          tabletImage {
            title
            url
            fileName
            contentType
          }
          smartphoneImage {
            title
            url
            contentType
            fileName
          }
          componentWidth {
            sys {
              id
            }
            name
            desktopComponentWidth
            smartphoneComponentWidth
            tabletComponentWidth
          }
        }
      }
       relatedProductsCollection(limit:6){
        items{
          sys{
            id
          }
          productName
          productShortName
          shortDescription
          parentPage{
            slug
          }
          slug
          breadcrumbTitle
          variantsCollection(limit:5){
            items{
              name
              variantName
              gtin
            }
          }
          gtin
           productCategoryType
          heroImage{
            sys{id}
            title
            contentType
            fileName
            url
            description
          }
          ratingAndReviewId  
        }
      }
      
     displayContentCollection(limit:1){
        items{
          sys{
            id
          }
          __typename
          ...on ContentTypeRichText{
            body
            styles
          }
        }
      }
      promosCollection {
        items {
          ... on HeadingTypes {
            ...HeadingFragment
            componentWidth {
              ...ComponentWidthFragment
            }
          }
          ... on Callout {
            ...CardFragment
          }
        }
      },
      videoArticle{
       ...VideoArticleFragment
      }
    }
  }
}`;
};
